
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Logo from 'src/components/Logo';

const CreditosDialog = ({openDialog, hCloseDialog}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            fullScreen={fullScreen}
            open={openDialog}
            onClose={hCloseDialog}
            aria-labelledby="responsive-dialog-title"
            maxWidth="lg"
            PaperProps={{sx:{borderRadius:10}}}
        >
            <div className="creditos-dialog">
                <div className="dialog-header">
                    <Logo />
                    <DialogActions>
                        <i class="times circle icon" onClick={hCloseDialog}> </i>
                    </DialogActions>
                </div>
                <DialogTitle id="responsive-dialog-title" className="creditos-title">
                    Créditos
                </DialogTitle>
                <DialogContent>
                    <div className="creditos">
                        <div className="unam inst">
                            <div className="dep">Universidad Nacional Autónoma de México</div>
                            <div className="entry">
                                <div className="roles"></div>
                                <div className="name">Dr. Leonardo Lomelí Vanegas</div>
                                <div className="role">Rector</div>
                            </div>
                        </div>
                        <div className="fmvz inst">
                            <div className="dep">Facultad de Medicina Veterinaria y Zootecnia</div>
                            <div className="entry">
                                <div className="roles">Académicas(os):</div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Irma Eugenia Candanosa Aranda
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Emma Lucía Serrano Sánchez
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Esperanza Itzel Yáñez Muñoz
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Jaime Córdova López
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Adriana Méndez Bernal
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Elizabeth Morales Salinas
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Mireya Juárez Ramírez
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Iván Ortega Cortés
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Isaac Martínez Racine
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Beatriz Vanda Cantón
                                </div>
                            </div>
                            <div className="entry">
                                <div className="roles">Alumnas(os):</div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Fernanda García Villordo
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    César Pérez Aquino
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    María de los Ángeles Gutiérrez Flores
                                </div>
                            </div>
                            <div className="entry">
                                <div className="name">
                                    Luis Angel Martínez Guadarrama
                                </div>
                            </div>

                        </div>
                        <div className="dgtic inst">
                            <div className="dep">
                                Dirección General de Cómputo y de
                                <br />
                                Tecnologías de información y comunicación
                            </div>
                            <div className="entry">
                                <div className="roles"></div>
                                <div className="name">Dra. Marina Kriscautzky Laxague</div>
                                <div className="rol">DITE</div>
                            </div>
                            <div className="entry">
                                <div className="roles">Académicas(os):</div>
                            </div>
                            <div className="entry">
                                <div className="name">Javier Rodrigo Díaz Espinosa</div>
                            </div>
                            <div className="entry">
                                <div className="name">Mario Alberto Hernández Mayorga</div>
                            </div>
                            <div className="entry">
                                <div className="name">Antonio Eder Navarro Mendoza</div>
                            </div>
                            <div className="entry">
                                <div className="name">Pablo Enrique Zenil Rivas</div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </div>
        </Dialog>
    );
};

export default CreditosDialog;
